(function () {

    'use strict';

    angular.module('app.core', [
        'ngRoute',
        'ngCookies',
        'ngSanitize',
        'angular-uuid',
        'ng.deviceDetector'
    ]);

})();



// WEBPACK FOOTER //
// ./app/core/core.module.js